import ReactGA from 'react-ga';
import { browserHistory } from 'react-router';
import * as consts from '../constants';

const getErrorString = v => {
  let s = ' is required';
  if (v.length > 2 && v[2]) {
    if (v[2][0] === '#')
      return v[2].slice(1);
    else
      return v[2] + s;
  }
  return v[0] + s;
}

const util = {
  validate: (validatorsList, model, formError) => {
    return !validatorsList.some(validator => {
      if (!validator[1](model)) {
        if (formError)
          formError(validator[0], getErrorString(validator));
        util.focus(validator[0]);
        return true;
      }
      return false;
    });
  },
  isEmailValid: (email) => {
    return new RegExp(consts.REGEX_EMAIL).test(email);
  },
  isPhoneValid: (phone) => {
    return new RegExp(consts.REGEX_PHONENO).test(phone);
  },
  isPostalCodeValid: (code) => {
    return new RegExp(consts.REGEX_POSTALCODE).test(code);
  },
  isBNValid: (bn) => {
    return new RegExp(consts.REGEX_BN).test(bn);
  },
  trackGoogleAnalytics: (productType, action, label, value) => {
    let event = {
      category: (productType && productType == consts.SERVICE_REMOVAL_NAME) ? 'Service Removal' : 'New Gas Service',
      action: action,
      label: label,
      value: value
    };
    ReactGA.event(event);
  },
  focus: elementName => {
    const element = document.getElementsByName(elementName);
    if (element.length > 0) {
      element[0].focus();
    }
  },
  formatCafePhoneNumber: (phone) => {
    if (typeof phone == 'undefined' || phone == null || phone == 'null' || phone == 'NULL' || phone == '') {
      return '';
    }
    else {
      if (phone) {
        phone = phone.replace(/[^\d]+/g, '');
        if (phone.length > 11) {
          return phone.substring(0, 3) + '-' + phone.substring(3, 6) + phone.substring(6, 10) + (phone.substring(10) != '' ? (' x ' + phone.substring(10)) : '');
        }
        else {
          return phone.substring(0, 3) + '-' + phone.substring(3, 6) + phone.substring(6);
        }
      }
      else {
        return '';
      }
    }
  },
  //just to add - inside of phone number with just digits
  formatingPhoneNumbers: (phone) => {
    if (typeof phone == 'undefined' || phone == null || phone == 'null' || phone == 'NULL' || phone == '') {
      return '';
    }
    if (phone.length === 10) {
      return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10)
    }
    else
      return phone;
  },
  parseCafePhoneNumber: (phone) => {
    if (!phone) return { phone: '', ext: '' };
    var ss = phone.split('x');
    return { phone: ss[0].trim(), ext: ss.length > 1 ? ss[1].trim() : '' };
  },
  routeToDashbord: (p) => {
    browserHistory.push('/dashboard');
  },
  getNamebyId: (items, id) => {
    let name = '';
    if (items && items.length > 0) {
      items.map((x) => {
        if (x.id == id)
          name = x.name;
      });
    }
    return name;
  },
  getIdFromNote: (note, optionName, lookupItems) => {
    if (note.noteType == "General" && note.text.startsWith('#') && note.text.includes(optionName)) {
      const indexOfOptionName = note.text.indexOf(optionName);
      if (indexOfOptionName == -1) return '';
      const indexOfColon = note.text.indexOf(':', indexOfOptionName);
      const indexOfNextHash = note.text.indexOf('#', indexOfOptionName);
      if (indexOfColon == -1 || indexOfNextHash == -1) return '';
      const value = note.text.substring(indexOfColon + 1, indexOfNextHash).trim();
      if (lookupItems)
        return util.getIdByName(value, lookupItems);
      else
        return value;
    }
    // else
    //   return '';
  },
  mapApplianceName: (name) => {
    switch (name) {
      case 'Hot Water Tank (HE)': return 'Water heater';
      case 'Barbeque': return 'Barbecue';
      case 'Fireplace - Heater': return 'Fireplace';
      case 'Furnace (primary/HE)': return 'Furnace';
      case 'Cooktop/Range': return 'Cooktop / Range';
      case 'Clothes Dryer': return 'Clothes dryer';
      case 'Hot Tub': return 'Hot tub';
      case 'Tankless Water Heater': return 'Tankless water heater';
      case 'Wall Heater': return 'Wall heater';
      default: return name;
    }
  },
  getIdByNameContains: (name, items) => {
    return items.find(p => p.name.indexOf(name) !== -1).id;
  },
  getIdByName: (name, items) => {
    return items.find(p => p.name.trim() == name).id;
  },
  formatPhoneNumber: (phone) => {
    if (typeof phone == 'undefined' || phone == null || phone == 'null' || phone == 'NULL' || phone == '') {
      return '';
    }
    else {
      phone = phone.replace(/[^\d]+/g, '');
      if (phone.length > 11) {
        return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10) + (phone.substring(10) != '' ? (' Extension ' + phone.substring(10)) : '');
      }
      else {
        return phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6);
      }
    }
  },
  DobFormatter: (dob) => {
    return dob.replace(new RegExp("/", "g"), "-");
  },
  isPlus19: (dob) => {
    //convert string to Date
    let DOB = new Date(dob);

    const year = DOB.getFullYear();
    const month = DOB.getMonth();
    const date = DOB.getDate();
    if (year && month != undefined && date) { //month can be 0-11
      var today = new Date();
      var birthDate = new Date(year, month, date);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      console.log(`you are ${age} years old :)`);
      if (age >= 19) {
        return true;
      }
      return false;
    }
    else {
      return true;
    }
  },
  toCafeAddress: address => {
    if (typeof address != 'undefined') {
      return address.unitNumber + ' ' +
        address.streetNumber + ' ' +
        ((!address.streetDirection.name || address.streetDirection.name == 'Please select') ? '' : address.streetDirection.name + ' ') +
        address.streetName + ' ' +
        (address.streetType ? (address.streetType + ' ') : '') +
        address.city + ' ' +
        address.province + ' ' +
        address.country + ' ' +
        address.postCode;
    }
    else return '';
  },
  toProjectStatus: status => {
    return (status == 'In Progress' || status == 'Application in progress') ? 'In progress' : status;
  },
  addressToString: address => {
    const addressParts = ["unitNumber", "streetNumber", "streetDirection", "streetName",
      "streetType", "city", "province", "country", "postCode"];
    let toRet = null;
    if (address)
      toRet = addressParts.reduce((m, n) => (m + ' ' + (address[n] ? address[n] : "")), "");
    return toRet;
  },
  dateFromString: s => {
    if (typeof s != 'undefined' && s != null && s != '') {
      var ns = s.indexOf('.') != -1 ? s.substring(0, s.indexOf('.')) : s;
      var re = /(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d)(Z?)/;
      var mr = ns.match(re);
      return new Date(mr[1], (+mr[2]) - 1, mr[3], mr[4], mr[5], mr[6]);
    }
  },
  toFullDateString: d => d ? d.toLocaleString('en-CA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' }) : '',
};

export default util;